export default {
    state: {
        superBomComponents: [],
        selectedRow: [],
        childBomNames: [],
        initialWidthSuperBomComponentTableColumns: [
            {
                label: 'Type component',
                field: 'type_component',
                type: 'text',
                filterOptions: {
                  styleClass: 'class1', // class to be added to the parent th element
                  enabled: true, // enable filter for this column
                  // placeholder: 'Filter', // placeholder for filter input
                  // filterValue: 'Jane', // initial populated value for this filter
                  filterDropdownItems: ['capacitor', 'resistor', 'mpn_component'], // dropdown (with selected values) instead of text input
                  // filterFn: this.columnFilterFn, //custom filter function that
                  trigger: 'enter', //only trigger on enter not on keyup
                },
            },
            {
                label: 'search_value',
                field: 'search_value',
                type: 'text',
                tdClass: 'md-body-1',
            },
            {
                label: 'quantity',
                field: 'quantity',
                type: 'number',
            },

        ],
        widthSuperBomComponentTableColumns: [],
    },

    actions: {
        async fetchSuperBomComponents(ctx, bomId) {
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/api/bomcomponent/?bom=" + bomId, requestParams);
            let superBomComponents = await res.json();
            ctx.commit('updateSuperBomComponents', superBomComponents)
        },
        async actionMoveSelectedToBom(ctx, props) {
            const movedBomComponents = []
            const deletedBomComponentIds = []
            const destinationRow = props['destinationRow']
            const selectedRows = props['selectedRows']
            const superBomComponents = JSON.parse(JSON.stringify(ctx.state.superBomComponents))
            const destinationBomComponent = superBomComponents[destinationRow.vgt_header_id]
            for (let selectedRow of selectedRows) {
                const appendChildren = superBomComponents[selectedRow.vgt_id].children.filter(
                    child => child.id === selectedRow.id);
                superBomComponents[selectedRow.vgt_id].children = superBomComponents[selectedRow.vgt_id].children.filter(
                    child => child.id !== selectedRow.id);
                destinationBomComponent.children = destinationBomComponent.children.concat(appendChildren)
                movedBomComponents.push.apply(movedBomComponents, appendChildren)
            }
            console.log('superBomComponents')
            console.log(superBomComponents)
            for (let selectedRow of selectedRows.reverse()) {
                if (superBomComponents[selectedRow.vgt_id].children.length === 0) {
                    deletedBomComponentIds.push(superBomComponents[selectedRow.vgt_id].id)
                    superBomComponents.splice(selectedRow.vgt_id, 1)
                }
            }
            const jsonUpdateComponent = JSON.stringify(destinationBomComponent)
            const requestUpdateBomComponent = {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
                body: jsonUpdateComponent
            };
            const resUpdateBomComponent = await fetch("/api/bomcomponent/" +
                destinationBomComponent.id + "/", requestUpdateBomComponent)

            if (resUpdateBomComponent.ok) {
                for (let deletedBomComponentId of deletedBomComponentIds) {
                    const requestOptions = {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                        },
                    };
                    await fetch("/api/bomcomponent/" + deletedBomComponentId + "/", requestOptions)
                }
                ctx.commit('updateSuperBomComponents', superBomComponents)
            } else {
                console.log('resUpdateBomComponent')
                console.log(resUpdateBomComponent)
            }
        },

        async actionRemoveFromGroup(ctx, row) {
            const superBomComponents = JSON.parse(JSON.stringify(ctx.state.superBomComponents))
            const bomComponent = superBomComponents[row.vgt_id]
            console.log('bomComponent')
            console.log(bomComponent)
            if (bomComponent.children.length > 1) {
                let newBomComponent = Object.assign({}, bomComponent);
                newBomComponent.id = null
                newBomComponent.quantity = row.quantity
                bomComponent.children = bomComponent.children.filter(component => component.id !== row.id)
                newBomComponent.children = newBomComponent.children.filter(component => component.id === row.id)
                newBomComponent.search_value = newBomComponent.children[0].search_value
                newBomComponent.search_value_not_empty = newBomComponent.children[0].search_value_not_empty
                const jsonNewComponent = JSON.stringify(newBomComponent)
                delete jsonNewComponent.id
                const requestCreateBomComponent = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        'credentials': "same-origin",
                    },
                    body: jsonNewComponent
                };
                const resCreateBomComponent = await fetch("/api/bomcomponent/",
                    requestCreateBomComponent)
                if (resCreateBomComponent.ok) {
                    superBomComponents[row.vgt_id] = bomComponent
                    superBomComponents.splice(row.vgt_id + 1, 0, newBomComponent)
                    ctx.commit('updateSuperBomComponents', superBomComponents)
                } else {
                    console.log('resCreateBomComponent')
                    console.log(resCreateBomComponent)
                }
            }
        },

    },
    mutations: {
        updateSuperBomComponents(state, superBomComponents) {
            let childBomNames = []
            let bomColumns = []
            for (let superBomComponent of superBomComponents) {
                let childrenCount = 0
                let childrenSum = 0
                for (let child of superBomComponent.children) {
                    childrenCount += 1
                    childrenSum += child['quantity'] * child['lot_size_for_super_bom']
                    superBomComponent[child.version] = child['quantity']
                    if (childBomNames.indexOf(child.version) === -1) {
                        childBomNames.push(child.version)
                        bomColumns.push(
                            {
                                label: child.version,
                                field: child.version,
                                headerField: child.version,
                                type: 'number',
                            },
                        )
                    }
                }
                superBomComponent['childrenCount'] = childrenCount
                superBomComponent['childrenSum'] = childrenSum
            }
            state.widthSuperBomComponentTableColumns = state.initialWidthSuperBomComponentTableColumns.concat(bomColumns)
            state.childBomNames = childBomNames
            state.superBomComponents = superBomComponents
        },
    },
    getters: {
        superBomComponents(state) {
            return state.superBomComponents
        },
        childBomNames(state) {
            return state.childBomNames
        },
        widthSuperBomComponentTableColumns(state) {
            return state.widthSuperBomComponentTableColumns
        },
    },
}
